<app-reports
  title="Capture Reports"
  [filtersForm]="filtersForm"
  [forceReportDetailsDisplay]="true"
  [reportsUrl]="reportsUrl"
  [reportsCountUrl]="reportsCountUrl"
  [outputOptionsForm]="outputOptionsForm">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-capture-status-and-reason-option
        formControlName="statusAndReasons"
        class="col-12" />

      <app-report-client-option
        formControlName="clientIds"
        [clientFilters]="{ applicableToReferralClaims: true }" />

      <app-report-sources-option
        formControlName="sources" />

      <app-report-pharmacy-partner-option
        formControlName="pharmacyPartnerNames" />

      <app-report-date-range-option label="Verification Date" formControlName="verifiedDate" />
      <app-report-date-range-option label="Created Date" formControlName="createdDate" />

      <app-report-boolean-option
        label="High Value"
        formControlName="highValueCandidatesOnly" />

      <app-report-text-option
        label="Days to Expiration"
        type="integer"
        formControlName="expiringWithinDays" />

      <ng-container [formGroup]="outputOptionsForm">
        <app-report-boolean-option
          label="Include PHI Data in Export"
          formControlName="includePhi" />
      </ng-container>

    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-client-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations" />

    <app-report-applied-capture-status-option
      [options]="report.filters" />

    <app-report-applied-capture-status-and-reason-option
      [options]="report.filters" />

    <app-report-applied-sources-option
      [options]="report.filters" />

    <app-report-applied-pharmacy-partner-option
      [options]="report.filters" />

    <app-report-applied-boolean-option
      [options]="report.filters"
      name="highValueCandidatesOnly"
      label="High Value" />

    <!-- filter removed but we can still display the old values -->
    <app-report-applied-boolean-option
      [options]="report.filters"
      name="activeClientsOnly"
      label="Active" />

    <app-report-applied-text-option
      [options]="report.filters"
      name="expiringWithinDays"
      label="Days to Expiration" />

    <app-report-applied-date-range-option
      [options]="report.filters"
      name="verifiedDate"
      label="Capture Verified Date" />

    <app-report-applied-date-range-option
      [options]="report.filters"
      name="createdDate"
      label="Capture Created Date" />

    <app-report-applied-boolean-option
      [options]="report.outputOptions"
      name="includePhi"
      label="Include PHI" />

  </ng-template>

</app-reports>
